import classNames from 'classnames';
import { FC } from 'react';

import Text, { TextProps } from '../Text';

// Component Definition
const Heading2: FC<TextProps> = props => (
  <Text
    as="h2"
    fontSize="heading2"
    {...props}
    className={classNames(props.className, 'text_heading2')}
  />
);

export default Heading2;
